import { UserActivityEvent } from "../../components/user-activity-events/models";
import { KeyValuePair } from "../models";

export const getHumanReadableEventType = (humanReadableEventTypes: Array<KeyValuePair> | undefined, eventType: string) => {
  return humanReadableEventTypes?.find(x => x.key === eventType)?.value ?? eventType;
};

export const getUserActivityObjectName = (obj: UserActivityEvent) => {
  if (!obj) {
    return null;
  }

  switch (obj.eventType) {
    case "INSURED_INSERT":
    case "INSURED_UPDATE":
    case "PROSPECT_INSERT":
    case "PROSPECT_UPDATE":
    case "REFERRAL_INSERT":
    case "REFERRAL_UPDATE":
    case "MGA_INSERT":
    case "MGA_UPDATE":
    case "CARRIER_INSERT":
    case "CARRIER_UPDATE":
    case "FINANCECOMPANY_INSERT":
    case "FINANCECOMPANY_UPDATE":
    case "OTHERTRUCKINGCOMPANY_INSERT":
    case "OTHERTRUCKINGCOMPANY_UPDATE":
      return getProperty<string>(obj?.payloadAfter, "commercialName");

    case "POLICY_INSERT":
    case "POLICY_UPDATE":
    case "POLICY_STATUS_CHANGED":
    case "QUOTE_INSERT":
    case "QUOTE_UPDATE":
      return getProperty<string>(obj?.payloadAfter, "number");
  }
};

function getProperty<T>(obj: any, path: string): T | undefined {
  return path.split('.').reduce((acc, key) => acc && acc[key], obj) as T | undefined;
}